/**
 * @param {number} duration duration in ms
 */
export function getDurationHoursAndMinutes(duration: number | undefined): {
	hours: number;
	minutes: number;
} {
	if (duration === undefined) {
		return { hours: 0, minutes: 0 };
	}

	const durationInSeconds = duration / 1000;

	const hours = Math.floor(durationInSeconds / 3600);
	const minutes = Math.round((durationInSeconds % 3600) / 60);

	return getHoursMinutesAdjustment(hours, minutes);
}

function getHoursMinutesAdjustment(
	hours: number,
	minutes: number,
): { hours: number; minutes: number } {
	return {
		hours: minutes === 60 ? hours + 1 : hours,
		minutes: minutes === 60 ? 0 : minutes,
	};
}
